import React from "react";
import Store from "../../content/Store";
import { Paths } from "../../constants/UrlConstants";
import Button from "../shared/buttons/Button";
import { connect } from "react-redux";
import { Layouts } from "../../constants/Constants";
import { getContentByVariationType } from "../../content/ContentDoneSimply";
import SSOContainer from "../shared/containers/SSOContainer";
import { logout } from "../../actions/rootActions";
import styles from "../../assets/css/modules/logout/logged-out.css";
import { SET_EXIT_SURVEY_URL } from "./loggedOutActions";
import loggedOutReducer from "./loggedOutReducer";
import MFASSOContainer from "../shared/containers/MFASSOContainer";
import mfaStyles from "../../assets/css/modules/containers/MFASSOContainer.css";

export function LoggedOut({
  exitSurveyType,
  logout,
  history
}) {
  let content = Store.LoggedOut;
  let mainSectionContent = getContentByVariationType(
    exitSurveyType,
    content.main
  );
  let returnToLoginButtonContent = content.returnToLoginButton;

  return (
    window?.axa?.features?.MFAFeature === "true"? 
    <MFASSOContainer mfaLogout={true}>
      <form>
        <h1 className={`axa-headline ${styles.mfaLoggedOutHeading}`} data-title>
          {mainSectionContent.heading}          
        </h1>
        <span>{mainSectionContent.subHeading1}</span>
        <div className="text-center">
          <div className="back-button">
          <p className="axa-body-text-4">
          <button
                id="noThanksButton"
                className={mfaStyles.buttonStart}
                label={returnToLoginButtonContent && returnToLoginButtonContent.label}
                onClick={() => {
                  logout();
                  history.push(Paths.HomeRoot);
                }}
              >{returnToLoginButtonContent && returnToLoginButtonContent.label}</button>
          </p>
          </div>
          </div>    
        
      </form>
    </MFASSOContainer>
    :<SSOContainer>
      <form>
        <h1 className={`axa-headline ${styles.loggedOutHeading}`} data-title>
          {mainSectionContent.heading}
        </h1>
        <div className="text-center">
          <div className="back-button col-sm-12">
          <p className="axa-body-text-4">
          <Button
                id="noThanksButton"
                label={returnToLoginButtonContent && returnToLoginButtonContent.label}
                onClick={() => {
                  logout();
                  history.push(Paths.HomeRoot);
                }}
              />
          </p>
          </div>
          </div>    
        
      </form>
    </SSOContainer>
  );
}

export const mapStateToLoggedOut = (state) => {
  let action = {
    type: SET_EXIT_SURVEY_URL,
    payload: state.layoutReducer.layout
  };
  let nstate = loggedOutReducer(state, action);
  let exitSurveyType = nstate.layoutReducer.layout;
  let exitSurveyUrl = nstate.exitSurveyUrl;
  return {
    exitSurveyUrl: exitSurveyUrl,
    exitSurveyType: exitSurveyType,
    isHOL: exitSurveyType === Layouts.HOL
  };
};

export default connect(mapStateToLoggedOut, { logout })(LoggedOut);
